// Contains all filters, imported in main.js
import Vue from "vue";

Vue.filter('date', function (value) {
    if (!value) return ''
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    let dateString = value.toString().split(" ")[0].replace(/-/g, "/")
    let currentDate = new Date(dateString)
    return months[currentDate.getMonth()] + " " + currentDate.getDate() + ", " + currentDate.getFullYear()
})

Vue.filter('keywords', function (value) {
    if (!value) return ''
    let keywords = ''
    for (let keyword of value) {
        keywords += keyword.name.trim() + ', '
    }
    return keywords.slice(0, -2)
})

Vue.filter('array', function (value) {
    if (!value) return ''
    let elements = ''
    for (let element of value) {
        elements += element + ', '
    }
    return elements.slice(0, -2)
})

Vue.filter('errors', function (value) {
    if (!value || value.length == 0) return ''
    // let errors = 'Error, please check the following:\n'
    let errors = ''
    for (let field in value) {
        errors += value[field] + '\n'
    }
    return errors
})

Vue.filter('video', function (value) {
    if (!value || value.length == 0) return ''
    if (value.startsWith('https') && value.includes("youtube")) return '<iframe src="' + value + "?&disablekb=1&modestbranding=1&rel=0" + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen/>'
    if (value.startsWith('https') && value.includes("vimeo")) return '<iframe src="' + value + "?&byline=0&dnt=1&portrait=0&title=0" + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen/>'
    return value
})